var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisconnectVpnIcon = function SvgDisconnectVpnIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF6C00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.181 8.681a4.504 4.504 0 0 1 1.903 6.405m-9.768-2.782L3.56 14.061a4.5 4.5 0 1 0 6.364 6.365l3.13-3.129m5.613-5.615 1.757-1.757A4.5 4.5 0 0 0 14.06 3.56l-4.5 4.5q-.388.39-.66.84m1.902 6.405a4.5 4.5 0 0 1-1.242-.88 4.5 4.5 0 0 1-1.062-1.683m12.494 8.252-5.907-5.907L8.898 8.9M2.991 2.991l5.907 5.91"
  })));
};
export { SvgDisconnectVpnIcon as ReactComponent };
export default __webpack_public_path__ + "a8b99f327eb12eb44211f1fd061bb3c4.svg";